<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>답변 템플릿 등록</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">사용여부</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group id="basicCustomUseyn" name="useyn">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="useY" name="useyn" class="custom-control-input" v-model="queryParams.use_yn" value="Y" checked>
                            <label class="custom-control-label" for="useY">사용</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="useN" name="useyn" class="custom-control-input" v-model="queryParams.use_yn" value="N">
                            <label class="custom-control-label" for="useN">미사용</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">순번</label>
                    </td>
                    <td class="" style="vertical-align:middle" v-if="formtype == 'insert' && queryParams.use_yn == 'Y'">
                      {{ templateTotalCnt }}
                    </td>
                    <td class="" style="vertical-align:middle" v-if="formtype == 'update' && queryParams.use_yn == 'Y'">
                      <select size="0" class="form-control" v-on:change="slotOnChange(queryParams, $event.target.value)">
                        <option v-for="optItem in selectSlotNumbers" :value="optItem.template_id+'|'+optItem.template_ord+'|'+optItem.title" :selected="optItem.template_ord == queryParams.template_ord">{{optItem.template_ord}}</option>
                        <!-- <option value="2" :selected="2 == data.item.slot_number">2</option>
                        <option value="3" :selected="3 == data.item.slot_number">3</option>
                        <option value="4" :selected="4 == data.item.slot_number">4</option>
                        <option value="5" :selected="5 == data.item.slot_number">5</option> -->
                      </select>
                      <!-- {{queryParams.template_ord != '' && queryParams.template_ord != null ? queryParams.template_ord : templateTotalCnt}} -->
                    </td>
                    <td class="" style="vertical-align:middle" v-if="queryParams.use_yn == 'N'">
                      미사용
                    </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">제목</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" name="title" type="text" v-model="queryParams.title" v-validate="'required'" :class="{'is-invalid': errors.has('title')}"></b-form-input>
                            <span v-show="errors.has('title')" :class="{error: errors.has('title')}">제목명은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">내용</label>
                      </td>
                      <td class="">
                        <vue-ckeditor v-model="queryParams.contents" :config="config" />
                      </td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                </b-col>
                <b-col md="4">
                  <b-button variant="success" v-on:click="saveDrTemplate()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/customer/qatemplate'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue';
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import VueCkeditor from 'vue-ckeditor2';

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    Multiselect,
    VueCkeditor,
  },
  data() {
    return {
      templateCode: '',
      templateTotalCnt: 0,
      pageOptions: [5, 10, 30, 50, 100],
      formtype: '',
      queryParams: {
        reg_date: moment().format('YYYY-MM-DD'),
        use_yn: 'Y',
      },
      selectSlotNumbers: [],
      items: [],
      config: {
        toolbar:[
          { name: 'document', items: [ 'Source', 'Preview'] },
          { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
          { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
          '-',
          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
          { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
          { name: 'links', items: ['Link', 'Unlink'] },
          '/',
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: [ 'Maximize' ] },
          { name: 'about', items: [ 'About' ] }
        ],
        font_names: 'Noto Sans KR/Noto Sans KR,sans-serif;맑은 고딕/Malgun Gothic;굴림/Gulim;돋움/Dotum;바탕/Batang;궁서/Gungsuh;',
        filebrowserImageUploadUrl:'backend/ftpserver/ckeditImageUpload',
        uploadUrl: 'backend/ftpserver/ckeditImageUpload?command=QuickUpload&type=Files&responseType=json',
        height: 300,
        versionCheck: false,
        extraPlugins: 'tableresize'
      },
    }
  },
  watch: {
  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.formtype = self.$route.query.status;
    self.templateCode = self.$session.get('templateCode');

    self.getTemplateMaxOrd();

    if(self.formtype == 'update'){
      self.getTemplateData(self.templateCode);
      self.findQATemplateList();
    }

  },
  methods: {
    // 템플릿 정보 조회
    getTemplateData(templateCode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/qaTemplate?access_token=' + token + '&templateCode=' + templateCode)
      .then((result) => {
        self.queryParams = result.data;
      })
    },
    // 템플릿 리스트 조회
    getTemplateMaxOrd() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/qaTemplateMaxOrd?access_token=' + token, data, null)
        .then((result) => {
          self.templateTotalCnt = result.data;
        })
    },
    // 템플릿 저장
    saveDrTemplate() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");
          self.queryParams.reg_id = self.$session.get('userId');

          if(self.queryParams.contents == ""){
            swal.fire({
              type: 'warning',
              title: '내용 부분은 필수로 작성해 주세요.',
              showConfirmButton: true,
            })
            return false;
          }

          if(self.formtype == 'insert' && self.queryParams.use_yn == 'Y'){
            self.queryParams.template_ord = self.templateTotalCnt;
          }

          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('objs', param);

          console.log(self.queryParams);

          if(self.formtype == 'insert'){
            self.$http.post('/api/insert/qaTemplate?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '템플릿이 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                    window.location = "#/customer/qatemplate";
                });
            })
          }else if(self.formtype == 'update'){
            self.$http.post('/api/update/qaTemplate?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '템플릿을 수정하였습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                    window.location = "#/customer/qatemplate";
                });
            })
          }
        }
      })
    },
    /**
    * 이미지 파일 업로드
    */
    uploadSummernoteImageFile(file, editor) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var data = new FormData();
      data.append("file", file);

      self.$http.post('/ftpserver/editorImageUpload?access_token='+token, data, null)
      .then((result) => {
        $(editor).summernote('insertImage', result.data);
      })
    },
    // 템플릿 리스트 조회
    findQATemplateList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      self.queryParams.use_yn = 'Y';

      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/qaTemplateList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          var itemCnt = self.items.length;
          self.selectSlotNumbers = [];
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
            el.selectchecked = false;
            if(el.use_yn == 'Y'){
              self.selectSlotNumbers.push(el);
            }
          });
          // console.log('self.selectSlotNumbers',self.selectSlotNumbers);
          // self.searchData.startday = self.queryParams.start_date;
          // self.searchData.endday = self.queryParams.end_date;
          // self.searchData.dayAllCheck = self.queryParams.day_code == 'dayall';
        })
    },
    slotOnChange(data, value){
      console.log('data',data);
      console.log('value',value);

      var self = this;
      var token = sessionStorage.getItem("myToken");
      var items = data;
      var preSlotNumArr = value.split("|");
      if(data.template_ord != preSlotNumArr[1]){
        // swal.fire({
        //   title: '순서 설정!',
        //   html: "<strong>이전 순서 - "+preSlotNumArr[2]+"("+preSlotNumArr[1]+")</br>변경 순서 - "+items.title+"(<span style='color:red'>"+items.template_ord+" => "+preSlotNumArr[1]+"</span>)</strong></br>변경 하시겠습니까?",
        //   type: 'warning',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#d33',
        //   confirmButtonText: 'OK'
        // }).then((swalResult) => {
        //   if (swalResult.value) {
            self.queryParams.template_id = items.template_id;
            self.queryParams.template_ord = items.template_ord;
            self.queryParams.old_template_id = preSlotNumArr[0];
            self.queryParams.old_template_ord = preSlotNumArr[1];
            // self.queryParams.reg_id = self.$session.get('userId');
            // var param = encodeURI(JSON.stringify(self.queryParams));
            // var data = new FormData();
            // data.append('objs', param);

            // console.log(self.queryParams);
        //     self.$http.post('/api/update/qaTemplateOrd?access_token='+token, data, null)
        //       .then((result) => {
        //         swal.fire({
        //           type: 'success',
        //           title: '순서가 설정되었습니다.',
        //           showConfirmButton: false,
        //           timer: 1000
        //         }).then(function() {
        //             $("#slotSelect"+selectNum).val(items.template_id+'|'+items.template_ord+'|'+items.title);
        //             self.findQATemplateList();
        //         });
        //     })
        //   }else{
        //     $("#slotSelect"+selectNum).val(items.template_id+'|'+items.template_ord+'|'+items.title);
        //   }
        // })
      }
    },
  }
}

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
<style src="daterangepicker/daterangepicker.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/customer/QATemplateForm.vue